import React from "react";
import Frame433 from "../Frame433";
import "./FAA3False.css";

function FAA3False(props) {
  const { className, frame433Props } = props;

  return (
    <div className={`faq3 ${className || ""}`}>
      <Frame433 line36={frame433Props.line36} className={frame433Props.className} />
    </div>
  );
}

export default FAA3False;
